<template>
  <div class="layout_container">
    <top-section :is-show-cube="false" />
  </div>
</template>

<script>
import TopSection from '../home-manage/components/topSection/index.vue'
export default {
  components: {
    TopSection,
  },
  data() {
    return {
      targetElement: null,
      observerElement: null,
    }
  },
  mounted() {

  },
  methods: {
  },
}
</script>

<style>
html {
  scroll-behavior: smooth; /* 启用平滑滚动 */
}
</style>
